import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Sidebar.css'; // Make sure styles are there
import Logo from '../../assets/dashboard/logo.png';

const Sidebar = ({ navItems, onLogout }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);

  return (
    <aside className={`sidebar col-md-${collapsed ? '1' : '2'}`} style={{minHeight:'100vh'}}>
      <div className="text-center mb-4">
        <img src={Logo} alt="Logo" className="dashboard-logo" style={{ width: collapsed ? '40px' : '100px' }} />
      </div>

      {navItems.map((item) => (
        <button
          key={item.path}
          className={`btn d-flex align-items-center ${location.pathname.includes(item.path)  ? 'active' : ''}`}
          onClick={() => navigate(item.path)}
        >
          <span className="me-2">{item.icon}</span>
          {!collapsed && <span>{item.label}</span>}
        </button>
      ))}

      <div className="mt-auto d-flex flex-column align-items-center">
        <button className="btn mb-2" onClick={onLogout}>
          <i className="bi bi-box-arrow-right"></i> {!collapsed && 'Log out'}
        </button>
        <button className="btn toggle-btn" onClick={() => setCollapsed(!collapsed)}>
          <i className={`bi ${collapsed ? 'bi-arrow-right-square' : 'bi-arrow-left-square'}`}></i>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;